import Cookies from 'js-cookie';

const takeActionDiv = document.querySelector('.take-action');
const donateDiv = document.querySelector('.donate');
const questionH2 = document.getElementById('question');

const COOKIE_ARRAY = ['supporter', 'name', 'email'];

const removeParam = (parameter) => {
  var url = document.location.href;
  var urlparts = url.split('?');

  if (urlparts.length >= 2) {
    var urlBase = urlparts.shift();
    var queryString = urlparts.join('?');

    var prefix = encodeURIComponent(parameter) + '=';
    var pars = queryString.split(/[&;]/g);
    for (var i = pars.length; i-- > 0; )
      if (pars[i].lastIndexOf(prefix, 0) !== -1) pars.splice(i, 1);
    url = urlBase + '?' + pars.join('&');
    window.history.replaceState('', document.title, url);
  }
  return url;
};

// Changes content in red tear section if supporter
const setTypeContent = () => {
  if (Cookies.get('supporter') === 'true') {
    if (takeActionDiv) {
      takeActionDiv.setAttribute('hidden', 'true');
    }
    if (donateDiv) {
      donateDiv.removeAttribute('hidden');
    }
  }
  return;
};

// Personalizes intro call to action question wording if name is set
const personalizeInfo = () => {
  if (!questionH2) {
    return;
  }
  questionH2.innerHTML = !!Cookies.get('name')
    ? `${Cookies.get(
        'name'
      )}, would <strong>YOU</strong> approve of this practice?`
    : 'Would <strong>YOU</strong> approve of this practice?';
};

// Personalizes take action section
const personalizeTakeAction = () => {
  const petitionActionAnchor = document.querySelector(
    '.take-action__item--petition'
  );
  const emailActionAnchor = document.querySelector('.take-action__item--email');

  if (!takeActionDiv || !petitionActionAnchor || !emailActionAnchor) {
    return;
  }

  if (Cookies.get('email') === 'true') {
    petitionActionAnchor.setAttribute('hidden', 'true');
    emailActionAnchor.removeAttribute('hidden');
  }
};

const checkParams = () => {
  const params = new URLSearchParams(window.location.search);

  if (!params) {
    return;
  }

  COOKIE_ARRAY.forEach((c) => {
    if (params.has(c)) {
      Cookies.set(c, params.get(c));
      removeParam(c);
    }
  });

  // window.history.pushState({}, document.title, window.location.pathname);
};

const modifyContent = () => {
  setTypeContent();
  personalizeInfo();
  personalizeTakeAction();
};

const customizeContent = () => {
  checkParams();
  modifyContent();
};

export default customizeContent;
